var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xl", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm.tracker && _vm.tracker.id === 0
                ? _c("h5", [
                    _vm._v(_vm._s(_vm.$t("map.gps.tracker.modal.add.title")))
                  ])
                : _c("h5", [
                    _vm._v(_vm._s(_vm.$t("map.gps.tracker.modal.edit.title")))
                  ]),
              _vm._v(" "),
              _c("span", { staticClass: "ml-auto" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("map.gps.tracker.modal.edit.lastGpsPositionUpdate") +
                      ": " +
                      _vm.lastPositionUpdate
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  staticStyle: { "margin-left": "revert" },
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.dismiss.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _vm.tracker
                  ? _c("Tabs", {
                      attrs: { tracker: _vm.tracker, disabled: !_vm.canEdit }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.canEdit
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.save }
                    },
                    [_vm._v(_vm._s(_vm.$t("btnSave")))]
                  )
                : _vm._e()
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }